export enum ArrowSize {
  SMALL = 8,
  MEDIUM = 9,
  DEFAULT = 10,
  BIG = 12,
  LARGE = 14,
}
